import styled from "@emotion/styled";
import { Col, Modal, Row, Select, Spin } from "antd";
import Button from "atoms/Button";
import COLORS from "common/Colors";
import { LEAVE_ICON } from "common/Constants";
import { useEffect, useRef, useState } from "react";
import { CSVLink } from "react-csv";
import LeaveDonutChart from "./LeaveDonutChart";
// import COLORS from 'common/Colors';

// Redux
import { reduce } from "lodash";
import { connect } from "react-redux";
import {
  getAllDepartmentList,
  getClientid,
  getUserList,
  getUserRoleId,
} from "redux/selectors";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const StyledModal = styled(Modal)`
  width: 700px !important;

  @media (max-width: 768px) {
    width: 95vw !important;
    max-width: 95vw !important;
    margin: 10px auto !important;
  }

  .ant-modal-body {
    height: 500px;
    max-height: 500px;
    overflow-y: auto;

    @media (max-width: 576px) {
      height: 70vh;
      max-height: 70vh;
      padding: 12px;
    }
  }

  .ant-modal-header {
    text-transform: uppercase;
    max-width: 95%;

    @media (max-width: 576px) {
      padding: 12px;
    }
  }
`;

const StyledCol = styled(Col)`
  margin-bottom: 10px;
`;

const ButtonOutlined = styled(Button)`
  padding: 5px 20px;
  border: 1px solid ${COLORS.PRIMARY};
  border-radius: 5px;
  background: transparent;
  font-weight: normal;
  color: ${COLORS.PRIMARY};
  white-space: nowrap;

  &:hover {
    border: 1px solid ${COLORS.PRIMARY};
    background: #f1f3f4;
    color: ${COLORS.PRIMARY};
  }
  &:focus {
    border: 1px solid ${COLORS.PRIMARY};
    background: #f1f3f4;
    color: ${COLORS.PRIMARY};
  }
  @media (max-width: 900px) {
    margin: 10px 0px;
  }
`;

const StyledSelect = styled(Select)`
  padding-bottom: 20px;
  .ant-select-arrow {
    top: 30% !important;
  }
  @media (max-width: 425px) {
    padding-bottom: 0px !important;
  }
`;

function DepartmentStaffLeaveBalance({
  displayModal,
  toggleModal,
  leaveTypeId,
  leaveName,
  selectedDepartmentId,
  leaveCategoryList,
  allDepartmentList,
  userList,
  clientId,
  leaveList,
  leaveCatgeory,
  filterDepartment,
  all,
  storeUserData,
  availableLeaves,
  departmentStatistics,
}) {
  console.log("departmentStatistics555", availableLeaves);
  const [userLeaves, setUserLeaves] = useState([]);
  const [displayLeaveReportLoader, toggleLeaveReportLoader] = useState(false);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [filter, setFilter] = useState([]);
  const [departmentName, setdepartmentName] = useState("");
  const [CSVDepartmentLeave, setCSVDepartmentLeave] = useState([]);
  const csvLinkDepartment = useRef();
  const [leaveSummary, setLeaveSummary] = useState({});
  const [departmentLeave, setDepartmentLeave] = useState({});
  console.log("departmentLeave12--->", departmentLeave);
  const [showMemberList, setShowMemberList] = useState(false);

  const filteredUserList = userList.filter((user) => user.statusid === "1");
  useEffect(() => {
    setFilteredUsers([]);
    setShowMemberList(false);
    setFilter([]);
  }, [displayModal]);

  const selecetDepartment = (id) => {
    let leaveStatistics = {};

    // 1. Filter users by department
    const teamFilteredUserList = filteredUserList.filter(
      (user) => Number(user.basedepartmentid) === Number(id)
    );
    console.log("teamFilteredUserList", teamFilteredUserList);

    // Initialize leave stats per user
    teamFilteredUserList.forEach((user) => {
      leaveStatistics[user.userid] = {
        available: 0,
        consumed: 0,
        carryforward: 0,
      };
    });
    console.log("leaveStatistics123-->", leaveStatistics);
    // 2. Filter approved leaves for department
    const approvedLeaves = availableLeaves.filter(
      (item) => Number(item.categoryid) === Number(id)
    );

    console.log("approvedLeaves223-->", approvedLeaves);

    // Prevent crash when empty
    const deptItems = approvedLeaves[0]?.items || [];

    // 3. Sum available & consumed for each user
    deptItems.forEach((leave) => {
      const userId = leave.userid;

      if (!leaveStatistics[userId]) {
        leaveStatistics[userId] = {
          available: 0,
          consumed: 0,
          carryforward: 0,
        };
      }

      leaveStatistics[userId].available += Number(leave.available || 0);
      leaveStatistics[userId].consumed += Number(leave.consumed || 0);
      leaveStatistics[userId].carryforward += Number(leave.carry_forward || 0);
    });

    console.log("leaveStatistics23", leaveStatistics);

    // 4. Prepare final UI array
    const updatedLeaveData = teamFilteredUserList.map((user) => {
      return {
        categoryName: user.fullname,
        categoryid: user.userid,
        data: [
          {
            type: "available",
            value: leaveStatistics[user.userid]?.available || 0,
            carryforward: leaveStatistics[user.userid]?.carryforward || 0,
          },
          {
            type: "consumed",
            value: leaveStatistics[user.userid]?.consumed || 0,
          },
        ],
      };
    });

    setDepartmentLeave(updatedLeaveData);
  };

  const showDepartmentMemberList = (id) => {
    selecetDepartment(id);
    setShowMemberList(true);
    setFilteredUsers([id]);
  };

  const CSVHeaders = [
    { label: "Employee ID" },
    { label: "Name" },
    { label: "Available Leaves" },
    { label: "Consumed Leaves" },
    { label: "Total Leaves" },
  ];
  const prepareCSV = async (event, done) => {
    if (showMemberList) {
      if (departmentLeave.length > 0) {
        setCSVDepartmentLeave(
          reduce(
            departmentLeave
              .filter((leave) => {
                if (filter && filter.length) {
                  return filter.includes(leave.categoryid);
                }
                return true;
              })
              ?.filter((value) => {
                const available =
                  value.data.find((item) => item.type === "available")?.value ||
                  0;
                const consumed =
                  value.data.find((item) => item.type === "consumed")?.value ||
                  0;
                return available !== 0 || consumed !== 0;
              }),
            function (result, leave) {
              result.push({
                Name: leave.categoryName,
                "Available Leaves": leave.data[0].value,
                "Consumed Leaves": leave.data[1].value,
                // "Total Leaves": leave.data[0].value + leave.data[1].valuee,
                CF: leave.data[0].carryforward,
              });
              return result;
            },
            []
          )
        );
        setTimeout(() => {
          csvLinkDepartment.current.link.click();
        });
      } else {
        console.log("No data available to download");
      }
    } else {
      if (availableLeaves.length > 0) {
        setCSVDepartmentLeave(
          reduce(
            availableLeaves?.filter((value) => {
              const available =
                value.data.find((item) => item.type === "available")?.value ||
                0;
              const consumed =
                value.data.find((item) => item.type === "consumed")?.value || 0;
              return available !== 0 || consumed !== 0;
            }),
            function (result, leave) {
              result.push({
                "Department ID": leave.categoryid,
                "Department Name": leave.categoryName,
                "Available Leaves": leave.data[0].value,
                "Consumed Leaves": leave.data[1].value,
                // "Total Leaves": leave.data[0].value + leave.data[1].value,
                CF: leave.data[0].carryforward,
              });
              return result;
            },
            []
          )
        );

        setTimeout(() => {
          csvLinkDepartment.current.link.click();
        });
      } else {
        console.log("No data available to download");
      }
    }
  };

  function findLeaveCategoryName(leaveCategoryList, leaveTypeId) {
    const leaveCategory = leaveCategoryList?.find(
      (category) => category?.leave_category_id === leaveTypeId
    );
    return leaveCategory
      ? leaveCategory?.leave_category_name
      : "Category not found";
  }
  const leaveCategoryName = findLeaveCategoryName(
    leaveCategoryList,
    leaveTypeId
  );
  const handleFilterChange = (newValue) => {
    setFilter(newValue);
  };

  return (
    <>
      <StyledModal
        title={
          showMemberList
            ? `${departmentName} - ${leaveCategoryName} Report`
            : `Overall ${leaveCategoryName} Report`
        }
        visible={displayModal}
        onCancel={toggleModal}
        footer={null}
      >
        <Spin spinning={displayLeaveReportLoader}>
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={24} md={8}>
              <p>Department</p>
              <StyledSelect
                showSearch
                style={{ width: "100%" }}
                placeholder="Search Department"
                name="user"
                optionFilterProp="department_name"
                options={allDepartmentList}
                fieldNames={{
                  label: "department_name",
                  value: "department_id",
                }}
                value={filteredUsers}
                onChange={(newValue) => {
                  const selectedDepartment = allDepartmentList?.find(
                    (dept) => dept.department_id === newValue
                  );
                  setFilteredUsers([newValue]);
                  setdepartmentName(selectedDepartment.department_name);
                  showDepartmentMemberList(newValue);
                }}
              />
            </Col>

            <Col xs={24} sm={24} md={8}>
              <p>Employee</p>
              <StyledSelect
                mode="multiple"
                showSearch
                style={{ width: "100%" }}
                placeholder="All"
                name="user"
                optionFilterProp="fullname"
                filterOption={(input, option) =>
                  option.fullname.toLowerCase().includes(input.toLowerCase())
                }
                filterSort={(optionA, optionB) => {
                  optionA.fullname
                    .toLowerCase()
                    .localeCompare(optionB.fullname.toLowerCase());
                }}
                options={filteredUserList}
                fieldNames={{
                  label: "fullname",
                  value: "userid",
                }}
                value={filter}
                onChange={handleFilterChange}
                disabled={!showMemberList}
              />
            </Col>

            <Col
              xs={24}
              sm={24}
              md={8}
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "flex-start",
              }}
            >
              <ButtonOutlined
                style={{ width: "100%" }}
                onClick={prepareCSV}
                disabled={availableLeaves[0]?.items?.length === 0}
              >
                Export CSV file
              </ButtonOutlined>
              <CSVLink
                header={CSVHeaders}
                data={CSVDepartmentLeave}
                filename={"Department Leave List.csv"}
                asyncOnClick={true}
                ref={csvLinkDepartment}
              />
            </Col>
          </Row>
          {console.log("departmentleave--->", departmentLeave)}
          {showMemberList ? (
            <Row gutter={16}>
              {Array.isArray(departmentLeave) &&
                departmentLeave
                  .filter((leave) => {
                    if (filter && filter.length) {
                      return filter.includes(leave.categoryid);
                    }
                    return true;
                  })
                  .filter((value) => {
                    const available =
                      value?.data?.find((item) => item.type === "available")
                        ?.value || 0;
                    const consumed =
                      value?.data?.find((item) => item.type === "consumed")
                        ?.value || 0;
                    return available !== 0 || consumed !== 0;
                  })
                  .map((value, index) => (
                    <StyledCol md={12} sm={24} xs={24} key={index}>
                      <LeaveDonutChart
                        iconName={LEAVE_ICON[7]}
                        title={value.categoryName}
                        data={value.data}
                        leaveId={leaveTypeId}
                      />
                    </StyledCol>
                  ))}
            </Row>
          ) : (
            <Row gutter={16}>
              {Array.isArray(availableLeaves) &&
                availableLeaves
                  // .filter(
                  //   (value) =>
                  //     filteredUsers.length === 0 ||
                  //     filteredUsers.includes(value.categoryid)
                  // )
                  .filter((value) => {
                    const available =
                      value?.data?.find((item) => item.type === "available")
                        ?.value || 0;
                    const consumed =
                      value?.data?.find((item) => item.type === "consumed")
                        ?.value || 0;
                    return available !== 0 || consumed !== 0;
                  })
                  .map((value, index) => (
                    <StyledCol
                      md={12}
                      sm={24}
                      xs={24}
                      key={index}
                      onClick={() => {
                        console.log("value.categoryid, ", value.categoryid);
                        showDepartmentMemberList(value.categoryid);
                        const selectedDepartment = allDepartmentList?.find(
                          (dept) => dept.department_id === value.categoryid
                        );
                        setdepartmentName(selectedDepartment.department_name);
                      }}
                    >
                      <LeaveDonutChart
                        iconName={LEAVE_ICON[7]}
                        title={value.categoryName}
                        data={value.data}
                        leaveId={leaveTypeId}
                      />
                    </StyledCol>
                  ))}
            </Row>
          )}
        </Spin>
      </StyledModal>
    </>
  );
}

const mapStateToProps = (state) => ({
  userRoleId: getUserRoleId(state),
  allDepartmentList: getAllDepartmentList(state),
  userList: getUserList(state),
  clientId: getClientid(state),
});

export default connect(mapStateToProps, null)(DepartmentStaffLeaveBalance);
